export default {
  table: {
    sortByColumn: 'Ordenar por {{column}}',
  },
  clipboard: {
    copyToClipboard: {
      success: '¡Copiado al portapapeles!',
      error: 'No se pudo copiar. Inténtalo de nuevo.',
    },
  },
};
